import React from 'react'
import { CBadge } from '@coreui/react'

// Badge del estado CALCULADO del préstamo (EstadoPrestamo.Calcular — fórmula
// GX en vivo). Colores: Nuevo = verde (FechaInicia = hoy), Vencido = rojo
// (FechaTermina < hoy y SaldoReal > 0 — arptpasadosdefecha.cs:288), No Pagó
// = naranja (Próximo cobro hoy sin abono), Pagado = gris, Activo = azul.
const COLORES: Record<string, string> = {
  Nuevo: 'success',
  'No Pagó': 'warning',
  Vencido: 'danger',
  Pagado: 'secondary',
  Activo: 'info',
}

const EstadoPrestamoBadge: React.FC<{ estado?: string }> = ({ estado }) => {
  if (!estado) return null
  return <CBadge color={COLORES[estado] ?? 'secondary'}>{estado}</CBadge>
}

export default EstadoPrestamoBadge
